const Pagination = ({ page = 1, limit = 50, total = 0, onPageChange, loading = false }) => {
  const totalPages = Math.max(1, Math.ceil(total / limit));
  if (totalPages <= 1) return null;
  return (
    <nav className="pagination" aria-label="ניווט בין עמודים">
      <button
        type="button"
        className="secondary"
        disabled={loading || page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        הקודם
      </button>
      <span>
        עמוד <strong>{page}</strong> מתוך <strong>{totalPages}</strong>
      </span>
      <button
        type="button"
        className="secondary"
        disabled={loading || page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        הבא
      </button>
    </nav>
  );
};
export default Pagination;
